import { connect } from 'react-redux';
import React from 'react';
import PropTypes from 'prop-types';
import URLSafeBase64 from 'urlsafe-base64';

import { Communicators } from 'presentation/components/lib/communicators';
import { determineFontColor } from 'lib/colorLogic';
import getRadius from 'lib/getRadius';
import isIE from 'lib/getCustomerProperties';
import overrideStyle from 'lib/overrideStyle';

const TRUNCATE_LENGTH = 25;

function FileMessageItem(props) {
  return (
    <OutlineWrapper tabIndex="0" sender={props.sender}>
      <FileItem
        alt={props.altText || `${props.sender} file`}
        data-aid="gladlyFileMessageItem"
        sender={props.sender}
        tabIndex="-1"
      >
        <DownloadLinkText download={props.fileName} href={props.downloadURL} target={isIE() ? '_blank' : '_self'}>
          {truncateText(props.fileName, TRUNCATE_LENGTH)}
        </DownloadLinkText>
      </FileItem>
    </OutlineWrapper>
  );
}

function truncateText(text, truncateLength) {
  return text.length <= truncateLength ? text : `${text.slice(0, truncateLength)}…`;
}

const DownloadLinkText = overrideStyle('a')`
  color: ${p => determineFontColor(p.theme.colors.attachmentBackground)};
  font-size: 13px;
  font-family : ${p => p.theme.fontLibrary.primary}
  padding: 12px;
  position: relative;
  top: 18px;
`;

const FileItem = overrideStyle('div')`
  text-align: center;
  align-self: ${p => (p.sender === Communicators.CUSTOMER ? 'flex-end' : 'flex-start')};
  background-color: ${p => p.theme.colors.attachmentBackground};
  border-radius: ${p => getRadius(p.theme.borderRadius, 8, 16)};
  flex: 0 0 auto;
  height: 56px;
  margin: 15px;
  object-fit: cover;
  outline: none;
  width: 200px;
  word-wrap: break-word;
`;

const OutlineWrapper = overrideStyle('div')`
  align-self: ${p => (p.sender === Communicators.CUSTOMER ? 'flex-end' : 'flex-start')};

  &:focus{
    box-shadow: 0 0 0px 2px #81b5ea;
  }
`;

FileMessageItem.propTypes = {
  altText: PropTypes.string,
  attachmentId: PropTypes.string,
  downloadURL: PropTypes.string.isRequired,
  fileName: PropTypes.string.isRequired,
  gladlyCustomerId: PropTypes.string.isRequired,
  sender: PropTypes.string.isRequired,
  src: PropTypes.string.isRequired,
};

export const mapStateToProps = (state, props) => {
  const { orgId, orgDomain } = state.app;
  const assetId = props.attachmentId ? encodeURIComponent(props.attachmentId) : '';
  const attachmentURL = URLSafeBase64.encode(btoa(props.src));
  const participantId = encodeURIComponent(props.gladlyCustomerId);
  const assetIdParam = assetId ? `assetId=${assetId}&` : '';
  const downloadURL = `${orgDomain}/api/smooch/v1/orgs/${orgId}/asset?${assetIdParam}url=${attachmentURL}&participantId=${participantId}`;

  return {
    ...props,
    downloadURL,
  };
};

const FileMessageItemContainer = connect(
  mapStateToProps,
  null
)(FileMessageItem);

export default FileMessageItemContainer;
